import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Kontaktní osoby"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Chrostek Oldřich - SAM "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Mobil: +420 608 741 124 E-mail: samsamuel@seznam.cz"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" PŮJČOVNA LODÍ: Kolář Rostislav - VYDRA"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Mobil: +420 777 709 500 E-mail: vydroch@seznam.cz "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" !!!POZOR ZMĚNA SÍDLA LODĚNICE!!! "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Frýdek-Místek, Místek, ul. Palkovická – objekt bývalých kasáren "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" GPS: 49°39'38.25\"N, 18°20'10.68\"E   "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Adresa pro doručování: "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" CHROSTEK OLDŘICH Jiřího Trnky 72, Frýdek - Místek, 738 02"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Číslo účtu: 2100348281 / 2010 ")
], -1)

import CommonPage from "@/components/CommonPage.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CommonPage, { title: "Kontaktní informace" }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})